/**
 * Optimiciti API Specification
 * Welcome to the Beta release of the Optimiciti API. This API allows registered users to make direct calls to our optimization solvers via a web request.  Use of the API requires acceptance of our terms of service.  Some useful links: - [Optimiciti Homepage](https://optimiciti.com) - [Optimiciti API Access Plans](https://optimiciti.com/pricing)
 *
 * The version of the OpenAPI document: 0.0.2
 * Contact: api@optimiciti.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The Location model module.
 * @module model/Location
 * @version 0.0.2
 */
class Location {
    /**
     * Constructs a new <code>Location</code>.
     * @alias module:model/Location
     * @param locationId {String} A string that uniquely identifies this location.
     * @param locationName {String} A name for this location (optional).
     */
    constructor(locationId, locationName) { 
        
        Location.initialize(this, locationId, locationName);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, locationId, locationName) { 
        obj['locationId'] = locationId;
        obj['locationName'] = locationName;
        obj['demand'] = 1;
        obj['isDepot'] = false;
        obj['serviceDuration'] = 0;
    }

    /**
     * Constructs a <code>Location</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/Location} obj Optional instance to populate.
     * @return {module:model/Location} The populated <code>Location</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new Location();

            if (data.hasOwnProperty('locationId')) {
                obj['locationId'] = ApiClient.convertToType(data['locationId'], 'String');
            }
            if (data.hasOwnProperty('locationName')) {
                obj['locationName'] = ApiClient.convertToType(data['locationName'], 'String');
            }
            if (data.hasOwnProperty('demand')) {
                obj['demand'] = ApiClient.convertToType(data['demand'], 'Number');
            }
            if (data.hasOwnProperty('latitude')) {
                obj['latitude'] = ApiClient.convertToType(data['latitude'], 'Number');
            }
            if (data.hasOwnProperty('longitude')) {
                obj['longitude'] = ApiClient.convertToType(data['longitude'], 'Number');
            }
            if (data.hasOwnProperty('x')) {
                obj['x'] = ApiClient.convertToType(data['x'], 'Number');
            }
            if (data.hasOwnProperty('y')) {
                obj['y'] = ApiClient.convertToType(data['y'], 'Number');
            }
            if (data.hasOwnProperty('isDepot')) {
                obj['isDepot'] = ApiClient.convertToType(data['isDepot'], 'Boolean');
            }
            if (data.hasOwnProperty('serviceDuration')) {
                obj['serviceDuration'] = ApiClient.convertToType(data['serviceDuration'], 'Number');
            }
            if (data.hasOwnProperty('minArrivalTimeInt')) {
                obj['minArrivalTimeInt'] = ApiClient.convertToType(data['minArrivalTimeInt'], 'Number');
            }
            if (data.hasOwnProperty('minArrivalTimeStr')) {
                obj['minArrivalTimeStr'] = ApiClient.convertToType(data['minArrivalTimeStr'], 'String');
            }
            if (data.hasOwnProperty('minArrivalDayInt')) {
                obj['minArrivalDayInt'] = ApiClient.convertToType(data['minArrivalDayInt'], 'Number');
            }
            if (data.hasOwnProperty('maxArrivalTimeInt')) {
                obj['maxArrivalTimeInt'] = ApiClient.convertToType(data['maxArrivalTimeInt'], 'Number');
            }
            if (data.hasOwnProperty('maxArrivalTimeStr')) {
                obj['maxArrivalTimeStr'] = ApiClient.convertToType(data['maxArrivalTimeStr'], 'String');
            }
            if (data.hasOwnProperty('maxArrivalDayInt')) {
                obj['maxArrivalDayInt'] = ApiClient.convertToType(data['maxArrivalDayInt'], 'Number');
            }
            if (data.hasOwnProperty('exactArrivalTimeInt')) {
                obj['exactArrivalTimeInt'] = ApiClient.convertToType(data['exactArrivalTimeInt'], 'Number');
            }
            if (data.hasOwnProperty('exactArrivalTimeStr')) {
                obj['exactArrivalTimeStr'] = ApiClient.convertToType(data['exactArrivalTimeStr'], 'String');
            }
            if (data.hasOwnProperty('exactArrivalDayInt')) {
                obj['exactArrivalDayInt'] = ApiClient.convertToType(data['exactArrivalDayInt'], 'Number');
            }
            if (data.hasOwnProperty('color')) {
                obj['color'] = ApiClient.convertToType(data['color'], 'String');
            }
            if (data.hasOwnProperty('vehicleTypeIds')) {
                obj['vehicleTypeIds'] = ApiClient.convertToType(data['vehicleTypeIds'], ['String']);
            }
            if (data.hasOwnProperty('fixedVehicleId')) {
                obj['fixedVehicleId'] = ApiClient.convertToType(data['fixedVehicleId'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>Location</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>Location</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of Location.RequiredProperties) {
            if (!data.hasOwnProperty(property)) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['locationId'] && !(typeof data['locationId'] === 'string' || data['locationId'] instanceof String)) {
            throw new Error("Expected the field `locationId` to be a primitive type in the JSON string but got " + data['locationId']);
        }
        // ensure the json data is a string
        if (data['locationName'] && !(typeof data['locationName'] === 'string' || data['locationName'] instanceof String)) {
            throw new Error("Expected the field `locationName` to be a primitive type in the JSON string but got " + data['locationName']);
        }
        // ensure the json data is a string
        if (data['minArrivalTimeStr'] && !(typeof data['minArrivalTimeStr'] === 'string' || data['minArrivalTimeStr'] instanceof String)) {
            throw new Error("Expected the field `minArrivalTimeStr` to be a primitive type in the JSON string but got " + data['minArrivalTimeStr']);
        }
        // ensure the json data is a string
        if (data['maxArrivalTimeStr'] && !(typeof data['maxArrivalTimeStr'] === 'string' || data['maxArrivalTimeStr'] instanceof String)) {
            throw new Error("Expected the field `maxArrivalTimeStr` to be a primitive type in the JSON string but got " + data['maxArrivalTimeStr']);
        }
        // ensure the json data is a string
        if (data['exactArrivalTimeStr'] && !(typeof data['exactArrivalTimeStr'] === 'string' || data['exactArrivalTimeStr'] instanceof String)) {
            throw new Error("Expected the field `exactArrivalTimeStr` to be a primitive type in the JSON string but got " + data['exactArrivalTimeStr']);
        }
        // ensure the json data is a string
        if (data['color'] && !(typeof data['color'] === 'string' || data['color'] instanceof String)) {
            throw new Error("Expected the field `color` to be a primitive type in the JSON string but got " + data['color']);
        }
        // ensure the json data is an array
        if (!Array.isArray(data['vehicleTypeIds'])) {
            throw new Error("Expected the field `vehicleTypeIds` to be an array in the JSON data but got " + data['vehicleTypeIds']);
        }
        // ensure the json data is a string
        if (data['fixedVehicleId'] && !(typeof data['fixedVehicleId'] === 'string' || data['fixedVehicleId'] instanceof String)) {
            throw new Error("Expected the field `fixedVehicleId` to be a primitive type in the JSON string but got " + data['fixedVehicleId']);
        }

        return true;
    }


}

Location.RequiredProperties = ["locationId", "locationName"];

/**
 * A string that uniquely identifies this location.
 * @member {String} locationId
 */
Location.prototype['locationId'] = undefined;

/**
 * A name for this location (optional).
 * @member {String} locationName
 */
Location.prototype['locationName'] = undefined;

/**
 * The amount of vehicle capacity this location consumes
 * @member {Number} demand
 * @default 1
 */
Location.prototype['demand'] = 1;

/**
 * The latitude for this location. Required only if autoCalculateDuration or autoCalculateDistance is true.
 * @member {Number} latitude
 */
Location.prototype['latitude'] = undefined;

/**
 * The longitude for this location. Required only if autoCalculateDuration or autoCalculateDistance is true.
 * @member {Number} longitude
 */
Location.prototype['longitude'] = undefined;

/**
 * Cartesian x position on an arbitrary plane (warehouse floor, factory layout, PCB). Unbounded - deliberately NOT range-validated, unlike longitude. Use with coordinateSystem=cartesian; x is the exact counterpart of longitude (x = longitude, y = latitude), so a scenario can migrate between the two families without reordering. Supply either latitude/longitude or x/y, never both.
 * @member {Number} x
 */
Location.prototype['x'] = undefined;

/**
 * Cartesian y position on an arbitrary plane. Unbounded - deliberately NOT range-validated, unlike latitude. Use with coordinateSystem=cartesian; y is the exact counterpart of latitude. Supply either latitude/longitude or x/y, never both.
 * @member {Number} y
 */
Location.prototype['y'] = undefined;

/**
 * Whether this location serves only as a depot for vehicles (true) or if this location should be serviced.
 * @member {Boolean} isDepot
 * @default false
 */
Location.prototype['isDepot'] = false;

/**
 * How long service at this location takes.
 * @member {Number} serviceDuration
 * @default 0
 */
Location.prototype['serviceDuration'] = 0;

/**
 * An integer value representing the earliest time this location can be serviced (time t=0 is the earliest start time). Leave empty if there are no time restrictions on pickup.
 * @member {Number} minArrivalTimeInt
 */
Location.prototype['minArrivalTimeInt'] = undefined;

/**
 * A string value representing the earliest time this location can be serviced (time t=0 is the earliest start time). Leave empty if there are no time restrictions on pickup. The time format should correspond to the timeFormat field in ProblemData.timeSettings.
 * @member {String} minArrivalTimeStr
 */
Location.prototype['minArrivalTimeStr'] = undefined;

/**
 * An integer value representing the earliest day this location can be serviced. Only relevant if ProblemData.timeSettings.multipleDays is true and ProblemData.timeSettings.timeUnit is \"clock\". Leave empty if there are no restrictions on pickup.
 * @member {Number} minArrivalDayInt
 */
Location.prototype['minArrivalDayInt'] = undefined;

/**
 * An integer value representing the latest time this location can be serviced (time t=0 is the earliest start time). Leave empty if there are no time restrictions on pickup.
 * @member {Number} maxArrivalTimeInt
 */
Location.prototype['maxArrivalTimeInt'] = undefined;

/**
 * A string value representing the latest time this location can be serviced (time t=0 is the earliest start time). Leave empty if there are no time restrictions on pickup. The time format should correspond to the timeFormat field in ProblemData.timeSettings.
 * @member {String} maxArrivalTimeStr
 */
Location.prototype['maxArrivalTimeStr'] = undefined;

/**
 * An integer value representing the latest day this location can be serviced. Only relevant if ProblemData.timeSettings.multipleDays is true and ProblemData.timeSettings.timeUnit is \"clock\". Leave empty if there are no restrictions on pickup.
 * @member {Number} maxArrivalDayInt
 */
Location.prototype['maxArrivalDayInt'] = undefined;

/**
 * An integer value representing the exact time this location must be serviced (time t=0 is the earliest start time). Leave empty if there are no time restrictions on pickup.
 * @member {Number} exactArrivalTimeInt
 */
Location.prototype['exactArrivalTimeInt'] = undefined;

/**
 * A string value representing the exact time this location must be serviced (time t=0 is the earliest start time). Leave empty if there are no time restrictions on pickup. The time format should correspond to the timeFormat field in ProblemData.timeSettings.
 * @member {String} exactArrivalTimeStr
 */
Location.prototype['exactArrivalTimeStr'] = undefined;

/**
 * An integer value representing the exact day this location must be serviced. Only relevant if ProblemData.timeSettings.multipleDays is true and ProblemData.timeSettings.timeUnit is \"clock\". Leave empty if there are no restrictions on pickup.
 * @member {Number} exactArrivalDayInt
 */
Location.prototype['exactArrivalDayInt'] = undefined;

/**
 * The color to use for this location in the output. This can be any valid hex color code.
 * @member {String} color
 */
Location.prototype['color'] = undefined;

/**
 * The vehicleTypeIds that can service this location. These vehicleTypeIds must exist in the VehicleTypes passed in ProblemData for this problem. Leave empty if there are no restrictions on which vehicle types can service this location.
 * @member {Array.<String>} vehicleTypeIds
 */
Location.prototype['vehicleTypeIds'] = undefined;

/**
 * Optional. Pin this location to a specific vehicle: the solve must use this vehicle to serve this stop. The vehicleId must exist in the Vehicles passed in ProblemData. If the pin cannot be satisfied - the vehicle does not exist, or its type is excluded by this location's vehicleTypeIds - the location is returned unassigned rather than served by a different vehicle. Leave null for no pin.
 * @member {String} fixedVehicleId
 */
Location.prototype['fixedVehicleId'] = undefined;






export default Location;

